<mat-form-field appearance="fill" class="w-full">
  <mat-label *ngIf="enableMatLabel">{{ 'Labels' | transloco }}</mat-label>
  <span matSuffix>
    <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
  </span>
  <mat-select
    #labelSelect
    (infiniteScroll)="onScroll()"
    [(ngModel)]="mainSelection"
    [compareWith]="compareLabels"
    [multiple]="true"
    [matTooltip]="getLabelsList() || ''"
    (openedChange)="toggleSelectOpened = !toggleSelectOpened"
    matTooltipClass="my-tooltip"
    msInfiniteScroll
  >
    <mat-option>
      <ngx-mat-select-search
        [formControl]="folderSearch"
        [noEntriesFoundLabel]="'No result found' | transloco"
        [placeholderLabel]="'Search' | transloco"
        [disableScrollToActiveOnOptionsChanged]="true"
      >
        <span matSuffix>
          <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
        </span>
      </ngx-mat-select-search>
    </mat-option>
    <!--    need to show all selection so that children are also shown-->
    <ng-container *ngIf="!toggleSelectOpened">
      <mat-option *ngFor="let label of selectedLabels" [value]="label" class="h-0">
        {{ label.folder_name | truncate: 30 : translateService.getActiveLang() | titlecase }}
      </mat-option>
    </ng-container>

    <!--      selected labels that are not present in list-->
    <!--    <ng-container *ngIf="!folderSearch.value && nonExistingSelectedLabels.length > 0 && !loading">-->
    <!--        <ng-container *ngFor="let label of nonExistingSelectedLabels;index as i">-->
    <!--            <mat-option-->
    <!--                    [value]="label"-->
    <!--                    #matOption-->
    <!--                    (click)="-->
    <!--          selectedLabels?.length < MAX_SELECTION || label.selected-->
    <!--            ? isUnselected(matOption, label)-->
    <!--            : null-->
    <!--        "-->
    <!--                    [disabled]="selectedLabels?.length >= MAX_SELECTION && !label.selected"-->
    <!--            >-->
    <!--        <span-->
    <!--                [innerHTML]="-->
    <!--            label.folder_name | truncate: 40 : translateService.getActiveLang() | titlecase-->
    <!--          "-->
    <!--                [matTooltip]="label.folder_name | titlecase"-->
    <!--        ></span>-->
    <!--                <mat-icon-->
    <!--                        svgIcon="mat_solid:arrow_drop_down"-->
    <!--                        *ngIf="label?.sub_folders?.length > 0"-->
    <!--                        (click)="onIconClick($event, label)"-->
    <!--                ></mat-icon>-->
    <!--            </mat-option>-->
    <!--            <ng-container *ngIf="label?.sub_folders?.length > 0 && label?.sub_folders[0]?.show">-->
    <!--                <mat-option-->
    <!--                        [disabled]="selectedLabels?.length >= MAX_SELECTION && !children.selected"-->
    <!--                        *ngFor="let children of label.sub_folders"-->
    <!--                        [value]="children"-->
    <!--                        #matOption2-->
    <!--                        [ngClass]="{-->
    <!--            L2: children.parent_id,-->
    <!--            hidden: !label.sub_folders[0].show-->
    <!--          }"-->
    <!--                        (click)="-->
    <!--            selectedLabels?.length < MAX_SELECTION || children.selected-->
    <!--              ? isUnselected(matOption2, children)-->
    <!--              : null-->
    <!--          "-->
    <!--                >-->
    <!--          <span-->
    <!--                  [innerHTML]="-->
    <!--              children.folder_name | truncate: 40 : translateService.getActiveLang() | titlecase-->
    <!--            "-->
    <!--                  [matTooltip]="children.folder_name | titlecase"-->
    <!--          ></span>-->
    <!--                </mat-option>-->
    <!--            </ng-container>-->
    <!--        </ng-container>-->
    <!--    </ng-container>-->

    <!--      the actual list that is being fetched-->
    <ng-container *ngFor="let label of labels">
      <mat-option
        [value]="label"
        #matOption
        (click)="
          selectedLabels?.length < MAX_SELECTION || label.selected
            ? isUnselected(matOption, label)
            : null
        "
        [disabled]="selectedLabels?.length >= MAX_SELECTION && !label.selected"
      >
        <span [matTooltip]="label.folder_name | titlecase" class="label-option">
          {{ label.folder_name | truncate: 40 : translateService.getActiveLang() | titlecase }}
        </span>
        <mat-icon
          class="label-expand mx-0"
          svgIcon="mat_solid:arrow_drop_down"
          *ngIf="label?.sub_folders?.length > 0"
          (click)="onIconClick($event, label)"
        ></mat-icon>
      </mat-option>
      <ng-container *ngIf="label?.sub_folders?.length > 0 && label?.sub_folders[0]?.show">
        <mat-option
          [disabled]="selectedLabels?.length >= MAX_SELECTION && !children.selected"
          *ngFor="let children of label.sub_folders"
          [value]="children"
          #matOption2
          [ngClass]="{
            L2: children.parent_id,
            hidden: !label.sub_folders[0].show
          }"
          (click)="
            selectedLabels?.length < MAX_SELECTION || children.selected
              ? isUnselected(matOption2, children)
              : null
          "
        >
          <span class="label-option" [matTooltip]="children.folder_name | titlecase">
            {{ children.folder_name | truncate: 40 : translateService.getActiveLang() | titlecase }}
          </span>
        </mat-option>
      </ng-container>
    </ng-container>
  </mat-select>
</mat-form-field>
